module.exports = __webpack_public_path__ + "img/wz-3-2.40658b25.jpg";